export const INTERACTIONS = {
  TAB: 'Tab',
}

export const DIRECTIONS = {
  DOWN: 'ArrowDown',
}
